import script from "./PatientCreationPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatientCreationPage.vue?vue&type=script&setup=true&lang=ts"

import "./PatientCreationPage.vue?vue&type=style&index=0&id=1f215748&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f215748"]])

export default __exports__